module.exports = __webpack_public_path__ + "static/media/ic_categories_accessary.d85363ad.svg";